import { material } from "../../Material/defaults";
import { EntryDataDoc, FilterObj } from "./useCutsheetSelector";
import { ImageData } from "./useCutsheetSelector";

function showFilters(doorType: string, typeOfData: string): FilterObj {
  if (doorType === "Bi-fold") {
    const common = {
      material: "Clad",
      screen: "none",
      screenType: "Brio",
    };

    if (typeOfData === "Head Jamb") {
      return common;
    }

    if (typeOfData === "Jamb Leg") {
      return {
        ...common,
        stiles: "Euro",
        screenPocket: "none",
        screenLayout: "Left Screen",
      };
    }

    if (typeOfData === "Sill") {
      return {
        ...common,
        sill: "Rounded Dam",
      };
    }
  }

  if (doorType === "Fixed Panel") {
    return {
      material: "Clad",
      config: "Fixed Bi-fold",
      sill: "Squared Dam",
    };
  }

  if (doorType === "Pivot") {
    const common = {
      material: "Clad",
    };

    if (typeOfData === "Jamb Leg") {
      return {
        ...common,
        sidelite: "none",
        sideliteSide: "Left",
        hinge: "LH",
      };
    }

    if (typeOfData === "Sill") {
      return {
        ...common,
        sill: "Raised",
      };
    }
  }

  if (doorType === "Slider") {
    const common = {
      material: "Clad",
      config: "OX",
      handle: "Truth",
      screen: "none",
      screenType: "Brio",
    };

    if (typeOfData === "Head Jamb") {
      return {
        ...common,
        jamb: '3 7/8"',
      };
    }

    if (typeOfData === "Jamb Leg") {
      return {
        ...common,
        screenPocket: "none",
        screenLayout: "Left",
        stiles: "Euro",
      };
    }

    if (typeOfData === "Sill") {
      return {
        ...common,
        sill: "Raised",
        jamb: '3 7/8"',
      };
    }
  }

  if (doorType === "Swing") {
    const common = {
      material: "Clad",
      screen: "none",
      // screenType: "Brio",
      swingDirection: "Outswing",
      stiles: "Euro",
    };

    if (typeOfData === "Sidelite Sill") {
      return {
        ...common,
        screenType: "Brio",
        screenPocket: "none",
        screenLayout: "Left",
      };
    }

    if (typeOfData === "Jamb Leg") {
      return {
        material: "Clad",
        swingDirection: "Outswing",
        swingType: "Single Swing",
        sidelite: "Single",
        sideliteSide: "Left",
        hinge: "LH",
        screen: "none",
        screenType: "Brio",
        screenPocket: "none",
        screenLayout: "Left",
        jamb: "5-1/8",
        stiles: "Euro",
      };
    }

    if (typeOfData === "Sill") {
      return {
        ...common,
        jamb: "5-1/8",
        screenType: "Brio",
      };
    }
  }

  return {};
}

function getOptions(doorType: string, key: string) {
  const options = {
    material: ["Clad", "Wood"],
    screen: ["none", "Single", "Double"],
    screenPocket: ["none", "Single", "Double"],
    screenLayout: ["Left", "Right"],
    sill:
      doorType === "Slider"
        ? ["Stainless Steel", "Raised"]
        : doorType === "Bi-fold"
          ? ["Rounded Dam", "Squared Dam", "Ultra Guide", "ADA Ultra Guide"]
          : doorType === "Fixed Panel"
            ? ["Rounded Dam", "Squared Dam"]
            : ["Aluminum", "Raised"],
    swingDirection: ["Inswing", "Outswing"],
    swingType: ["Single Swing", "Pair Swing"],
    sidelite: ["none", "Single", "Double"],
    jamb:
      doorType === "Swing"
        ? ["5-1/8", "6-1/16", "7", "7-15/16"]
        : ["3 7/8", "4 1/8", "5 3/4", "6"], //5 1/8 is inswing clad, the rest is for clad px slider
    screenType:
      doorType === "Slider"
        ? ["Brio", "Centor", "Sliding"]
        : ["Brio", "Centor"],
    config:
      doorType === "Fixed Panel"
        ? [
            "Fixed Bi-fold",
            "Fixed Slider",
            "Fixed Full Bound",
            "Fixed Inswing",
            "Fixed Outswing",
          ]
        : [
            "OX",
            "XO",
            "OX-AO",
            "OA-XO",
            "OXX",
            "XXO",
            "OXX-AXO",
            "OXA-XXO",
            "OXXX",
            "XXXO",
            "OXXX-AXXO",
            "OXXA-XXXO",
            "OXXXX",
            "XXXXO",
            "OXXXX-AXXXO",
            "OXXXA-XXXXO",
            "PX",
            "XP",
            "PX-AP",
            "PA-XP",
            "PXX",
            "XXP",
            "PXX-AXP",
            "PXA-XXP",
            "PXXX",
            "XXXP",
            "PXXX-AXXP",
            "PXXA-XXXP",
            "PXXXX",
            "XXXXP",
            "PXXXX-AXXXP",
            "PXXXA-XXXXP",
            "XX Left Primary",
            "XX Right Primary",
            "XXX Left Primary",
            "XXX Right Primary",
            "XXXX Left Primary",
            "XXXX Right Primary",
          ],
    handle: ["Hoppe", "Truth", ""],
    stiles:
      doorType?.includes("Bi-fold") || doorType?.includes("Swing")
        ? ["Euro", "Slimline", "Traditional", "Pico"]
        : ["Euro", "Slimline", "Traditional"],
    hinge: ["LH", "RH"],
    sideliteSide: ["Left", "Right"],
    // cornerType: ["Outside", "Inside"],
    // primaryDoor: ["Left", "Right"],
    // cornerSide: ["left", "right"]
  };

  return options[key] || [];
}

function hideFilters(doorType: string, typeOfData: string, filter: FilterObj) {
  let hidden: string[] = [];

  if (doorType === "Swing") {
    hidden = hidden.concat("sill");
    if (filter.sidelite === "none" || filter.sidelite === "Double") {
      hidden = hidden.concat(["sideliteSide"]);
    }
    if (filter.swingDirection !== "Inswing" || filter.material !== "Clad") {
      hidden = hidden.concat(["jamb"]);
    }
    if (filter.swingDirection !== "Outswing") {
      hidden = hidden.concat(["screen"]);
      hidden = hidden.concat(["screenType"]);
      hidden = hidden.concat(["screenPocket"]);
      hidden = hidden.concat(["screenLayout"]);
    }
  } else if (doorType === "Slider") {
    const px = ["PX", "XP", "PX-AP", "PA-XP"];

    if (filter.material !== "Clad" || !px.includes(filter.config || "")) {
      hidden = hidden.concat(["jamb"]);
    }
  }

  if (
    filter.screen === "none" 
    // &&
    // !(doorType === "Swing" &&
    //   typeOfData === "Sidelite Sill" &&
    //   filter.stiles?.includes("Pico"))
  ) {
    hidden = hidden.concat(["screenLayout", "screenPocket", "screenType"]);
  }

  return hidden;
}

function inputLabelFormat(key: string) {
  let str = key[0].toUpperCase();
  for (let i = 1; i < key.length; i++) {
    let letter = key[i];
    const charCode = letter.charCodeAt(0);
    if (charCode >= 65 && charCode <= 90) {
      //upper case
      str += " " + letter;
    } else {
      str += letter;
    }
  }
  return str;
}

const reorder = (list: any[], startIndex: number, endIndex: number) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

function cutsheetDataChange(
  prev: EntryDataDoc[],
  id: string,
  key: string,
  value: string,
) {
  return prev.map((itm) => (itm._id === id ? { ...itm, [key]: value } : itm));
}

function removeIdFieldFromCutsheets(data: EntryDataDoc[]) {
  const cutsheet: Omit<EntryDataDoc, "_id">[] = JSON.parse(
    JSON.stringify(data),
  );

  let emptyFields = false;

  for (let itm of cutsheet) {
    if (emptyFields) break;
    delete itm["_id"];
    emptyFields = Object.values(itm).some((value) => !value);
  }

  return {
    cutsheet,
    emptyFields,
  };
}

function formatImageData(
  publicId: string,
  width: number,
  height: number,
  type: string,
  uploadResult: string,
): ImageData {
  return {
    publicId,
    metadata: {
      width,
      height,
      type, // Extracts file extension as type
    },
    uploadResult,
  };
}

export {
  reorder,
  inputLabelFormat,
  hideFilters,
  getOptions,
  showFilters,
  cutsheetDataChange,
  removeIdFieldFromCutsheets,
  formatImageData,
};
